<template>
  <div v-if="userSubscriptionError" class="d-flex justify-content-center align-items-center">
    <b-card class="text-center mt-5">
      <b-alert fade show class="m-3" variant="danger">
        <small>{{ $t('security.userSubscriptionError') }}</small>
      </b-alert>
    </b-card>
  </div>
</template>

<script>

import { mapActions } from 'vuex'
export default {
  name: 'CheckSubscription',
  data(){
    return{
      userSubscriptionError: false
    }
  },
  created(){
    this.checkUserSubscription()
  },
  methods:{
    ...mapActions({
      checkUserSub: 'subscription/checkAlreadyUserSub'
    }),
    checkUserSubscription(){
      var code = this.$route.params.code
      let payload = {
        code: code
      }
      this.checkUserSub(payload)
        .then(response => {
          var result = response.body.result
          if(result.state === 'Subscribe'){
            console.log(`userName=${result.username};domain=${window.location.host};path=/`)
            let encodedUserName = encodeURIComponent(result.username)
            document.cookie = `userName=${encodedUserName.replace(/%/g, "percent")};path=/`    
            /* for tpay hash userNames, its making
            sure that getUserState is truely
            work. the percent word in backend 
            must be replace with "%" character  */
            //document.cookie = `userName=${result.username};domain=${window.location.host};path=/`
            setTimeout(() => {
              window.location = `/?userName=${result.username}`
            }, 2000)
          }else{
            this.userSubscriptionError = true
          }
      })
    }
  }
}
</script>
